/**
 * Created by sung on 2017-02-07.
 */
import {Component, OnInit} from '@angular/core';
import {NgModule} from '@angular/core';
import {DataTableModule,TabViewModule,PanelModule,ButtonModule,PaginatorModule} from "primeng/primeng";
import {BrowserModule} from "@angular/platform-browser";
import {HttpModule} from "@angular/http";
import {RouterModule} from "@angular/router";
import { MamAdminService } from '../../service/mam_service.component';
import { Device } from '../../model/device';
import {SelectItem} from "primeng/components/common/api";
import {SearchModule} from "../../component/search.component";
import {DatePipe} from "@angular/common";
import {DatexPipe} from "../../pipe/datex.pipe";
import {MainPipeMoudle} from "../../pipe/main.pipe";
import {Logger, Options, Level } from "angular2-logger/core"; // ADD THIS
import {TranslateServiceForm, TranslatePipeMoudle} from "../../translate";

@Component({
selector: 'statistics',
templateUrl: './device_statistics.html'
})
export class DeviceStatisticsComponent implements OnInit {

  private device_list : Device[] = [];
  totalRecord : number = 10;
  searchIDs: SelectItem[];

  dateIsTrue : boolean;

  searchIsTrue : boolean;
  excelIsTrue : boolean = true;
  sDate: string;
  eDate: string;

  searchText: string;
  searchId : string;
  pageMax : number;

  date : Date= new Date();
  datePipe : any = new DatePipe("en");
  ngOnInit() {
    let nDate = new Date();
    nDate.setDate(nDate.getDate()-15);

    this.getDeviceCondition(1, 10, this.datePipe.transform(nDate, 'yyyy-MM-dd'),this.datePipe.transform(this.date, 'yyyy-MM-dd'), "", "", "");
  }

  constructor(private service : MamAdminService, private logger : Logger, private translate : TranslateServiceForm) {
    this.searchIDs = [];
    this.searchIDs.push({label: '---------------', value: 'all'});
    this.searchIDs.push({label: this.translate.instant("LANG_USR_user"), value: 'username'});
    this.searchIDs.push({label: this.translate.instant("LANG_PhoneNumber"), value: 'mobileNumber'});
    this.searchIDs.push({label: this.translate.instant("IsRooting"), value: 'isRooted'});
    this.searchIDs.push({label: this.translate.instant("IsRegistered"), value: 'isRegistered'});

    this.dateIsTrue = true;
  }

  getSearchModel(event){
    this.logger.debug("event : ",event);
    this.searchIsTrue = event.searchIsTrue;
    this.searchText = event.searchText;
    this.sDate = event.sDate;
    this.eDate = event.eDate;
    this.searchId = event.searchId;

    this.getDeviceCondition(1, this.pageMax, this.sDate, this.eDate, this.searchText, "true", this.searchId);
  }

  paginate(event) {
    this.pageMax = event.rows;
    let nDate = new Date();
    nDate.setDate(nDate.getDate()-15);
    if (this.searchIsTrue) {

      this.getDeviceCondition(event.page + 1, this.pageMax, this.sDate, this.eDate, this.searchText, "true", this.searchId);
    } else {
      this.getDeviceCondition(event.page + 1, this.pageMax, this.datePipe.transform(nDate, 'yyyy-MM-dd'),this.datePipe.transform(this.date, 'yyyy-MM-dd'), "", "", "");
    }

  }


  getDeviceCondition(page:number, max:number, start:string, end:string, search:string, like:string, field:string) {
    this.service.getDeviceCondition(page, max, start, end, search, like, field).subscribe(
        value => {
          this.device_list = value.rows;
          this.totalRecord = value.total;
          this.logger.debug("-- device_list :", value);
        },
        error => {
          this.logger.error("-- error : " + error);
        },
        () => {
          this.logger.info("-- complate : ");
        }
      )
  }

  excelExport(event){
    this.logger.debug("excel 다운 : ",event);
    if(event){
      //엑셀 다운 진행.
    }
  }


}


@NgModule({
  imports: [DataTableModule,TabViewModule,PanelModule,BrowserModule,HttpModule, RouterModule,ButtonModule,PaginatorModule,SearchModule,MainPipeMoudle,TranslatePipeMoudle],
  exports: [DeviceStatisticsComponent],
  declarations: [DeviceStatisticsComponent],
  providers: [MamAdminService],
})
export class DeviceStatisticsModule {
}



// WEBPACK FOOTER //
// ./src/app/page/device/device_statistics.ts